import { PropTypes } from 'prop-types'
import { DropzoneArea } from 'material-ui-dropzone';
import React, { useState } from 'react'
import { uploadFile } from 'react-s3';
import LoadingHook from './LoadingHook';
import { Typography } from '@material-ui/core';

export default function S3FileUpload_Hook({ selectedImg, user }) {


    // const [uploadFileLocation, setUploadFileLocation] = useState()
    const [isUpload_Loading, setIsUpload_Loading] = useState()


    const upload = async (files) => {

        if (files.length === 0) return;

        setIsUpload_Loading(true)


        // user s3 folder is user._id
        const config = {
            bucketName: process.env.REACT_APP_S3_BUCKET_NAME,
            dirName: process.env.REACT_APP_S3_FOLDER_NAME + user._id,
            region: process.env.REACT_APP_S3_REGION,
            accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
        }


        uploadFile(files[0], config)
            .then((data) => {

                console.log('data:', data)

                // key: "seller-media/60f896f2a7fe9f22d4fcb412/drawerBG2-min.jpg"
                // "https://shopping-cart-x.s3.amazonaws.com/seller-media/60f896f2a7fe9f22d4fcb412/aliexpress.png"               
                // const fileName = data.location.split(process.env.REACT_APP_S3_PATH)[1];
                const fileName = data.location.split(process.env.REACT_APP_S3_PATH + user._id + '/')[1];
                console.log('upload fileName:', fileName)

                selectedImg(fileName)
                // setUploadFileLocation(fileName)
                setIsUpload_Loading(false)
            })
            .catch((err) => {

                setIsUpload_Loading(false)
                console.error(err)
            })
    }


    return (
        <div className='gal-root' style={{ minHeight: '25rem' }}>
            <Typography gutterBottom variant='h4' color="textSecondary" className='gal-header'>
                Image Upload
            </Typography>
            <DropzoneArea
                acceptedFiles={['image/jpeg,image/png,image/gif,image/svg,image/jpg']}
                filesLimit={Number(1)}
                maxFileSize={Number(2000000)} // bytes
                dropzoneText={"Drag and drop an image here or click"}
                onChange={(file) => upload(file)}
                renameFile={(file) => { return new Date().getTime() + '_' + file.name }}
                required
            />
            {isUpload_Loading && <LoadingHook isSmall />}

        </div>
    )
}

S3FileUpload_Hook.propTypes = {
    user: PropTypes.object,
    selectedImg: PropTypes.func,
}